import { useThemeProvider } from '../utils/ThemeContext';
import Toast2 from './Toast2';

export default function Header({
    heading,
    toastErrorOpen,
    setToastErrorOpen,
    toastErrorMsg
}){
    const { attribs } = useThemeProvider();

    return(
        <div>
            <div className="flex justify-center">
                <img
                    alt=""
                    className="max-w-xs"
                    src={attribs.logo}/>
            </div>
            <div className="mt-4 text-center">
                <p className="text-[13px] font-semibold tracking-[0.25em] uppercase text-gray-400">
                    Security Operations Platform
                </p>
            </div>
            <h2 className="mt-2 text-center text-sm text-gray-600 mt-5">
                {<Toast2 type="error" open={toastErrorOpen} setOpen={setToastErrorOpen}>{toastErrorMsg}</Toast2>}
            </h2>
        </div>
    )
}
